import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/batches/export-excel`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportExcel = {
  post: apiPathFunc(pathBase),
};
